angular.module('pe4h').controller('Login', function($scope, $rootScope, $state, $http, configuration, AuthService) {

    $scope._loginSuccess = function(res){
        var new_token = res.Token;
        $scope.loadUser(res.User);
        AuthService.save(new_token);

        if($state.params && $state.params.next && $state.params.params){
            var nextParams = JSON.parse($state.params.params)
            $state.go($state.params.next, nextParams);
        }else{
            if($rootScope.previousState && $rootScope.previousState.name!='' && $rootScope.previousState.name!='index' && $rootScope.previousState.name!='login' && $rootScope.previousState.name!='recoverPassword' && $rootScope.previousState.name!='signup')
                $state.go($rootScope.previousState.name, $rootScope.previousParams);
            else{
                if ($scope.user.IsProfessional)
                    $state.go('proposals', {});
                else
                    $state.go('projects', {});
            }
        }
    };

    $scope.init = function(){
        var token = AuthService.get();
        // Validate the current token
        if(token){
            $http({
                url: configuration.webApi.auth.token,
                method: "POST",
                data: {
                    "Token": token
                },
                skipInterceptors: true
            }).success(function(res, status, headers, config) {
                $scope._loginSuccess(res);
            }).error(function(error, status, headers, config) {
            });
        }
    };

    $scope.signup = function() {
        $http({
            url: configuration.webApi.users.professional,
            method: "POST",
            data: {
                "Email": $scope.mail,
                "FirstName": $scope.firstName,
                "LastName": $scope.lastName
            },
        }).success(function(res, status, headers, config) {
            var new_token = res.Token;
            AuthService.save(new_token);
            $scope.loadUser(res.User);
            $state.go('edit-profile', { "first": true });

        }).error(function(error, status, headers, config) {
            $scope.alertErrorFromServer(error);
        });
    }

    $scope.login = function() {
        if($scope.criticalMessageNotFound){
            $scope.alertError('Error', "Could not retrieve information from server.");
        }
        else{
            $http({
                url: configuration.webApi.auth.login,
                method: "POST",
                data: {
                    "Email": $scope.mail,
                    "Password": $scope.password
                },
                skipInterceptors: true
            }).success(function(res, status, headers, config) {
                $scope._loginSuccess(res);
            }).error(function(error, status, headers, config) {
                $scope.alertErrorFromServer(error);
                //authFactory.logout();
            });
        }
    }

    $scope.init();
});
